import * as actionTypes from 'constants/ActionTypes';

const statisticsEmails = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
    from: '',
    until: '',
}, action) => {
    switch (action.type) {
        case actionTypes.GET_STATISTICS_EMAILS.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_STATISTICS_EMAILS.SUCCESS: {
            const items = action.data;

            items.sort((a, b) => {
                return new Date(a.realDate) - new Date(b.realDate);
            });

            return {
                ...state,
                items,
                isLoaded: true,
            };
        }
        case actionTypes.GET_STATISTICS_EMAILS.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };
        case actionTypes.SEARCH_STATISTICS_EMAILS:
            return {
                ...state,
                searchText: action.searchText,
            };
        default:
            return state;
    }
};

export default statisticsEmails;



// WEBPACK FOOTER //
// ./app/reducers/statistics/emails.js